import React from 'react';
import { Link } from 'react-router-dom';
type TocItem = {
  id: string;
  title: string;
};
export function EntryToc({
  items,
  variant
}: {
  items: TocItem[];
  variant: 'side' | 'inline';
}) {
  if (variant === 'inline') {
    return <nav aria-label="En esta ficha" className="-mx-5 px-5 sm:mx-0 sm:px-0" data-id="element-587" data-mp="tkf2vuskgkqr">
        <p className="mb-2 text-xs font-semibold text-gray-500" data-id="element-588" data-mp="omdjt9v54lfa">En esta ficha</p>
        <ul className="flex gap-2 overflow-x-auto pb-1" data-id="element-589" data-mp="wjb94hutj0u">
          {items.map(t => <li key={t.id} className="shrink-0" data-id="element-590" data-mp="3t13nzc6muizv">
              <Link to={{
            hash: t.id
          }} className="inline-flex h-9 items-center rounded-full border border-white/10 px-3.5 text-sm text-gray-300 whitespace-nowrap transition-colors duration-150 hover:border-[#D4AF37]/40 hover:text-white" data-id="element-591" data-mp="3t2errc02vqqz">
                {t.title}
              </Link>
            </li>)}
        </ul>
      </nav>;
  }
  return <nav aria-label="En esta ficha" className="sticky top-28" data-id="element-592" data-mp="39de4ds8unp1q">
      <p className="mb-3 text-xs font-semibold text-gray-500" data-id="element-593" data-mp="39arwfri1r7iz">En esta ficha</p>
      <ul className="space-y-1 border-l border-white/10" data-id="element-594" data-mp="2207z2j5dhobl">
        {items.map(t => <li key={t.id} data-id="element-595" data-mp="26yj8wtvo3ytt">
            <Link to={{
          hash: t.id
        }} className="-ml-px block border-l-2 border-transparent py-1.5 pl-4 text-sm text-gray-400 transition-colors duration-150 hover:border-[#D4AF37] hover:text-white" data-id="element-596" data-mp="26xrdpk5zg342">
              {t.title}
            </Link>
          </li>)}
      </ul>
    </nav>;
}